import { Spin } from "antd"
import { FullScreenLoaderContainer } from "./styled"

export const Loader: React.FC = () => {
  return <FullScreenLoaderContainer>
    <Spin size="large" />
  </FullScreenLoaderContainer>
}